/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SegnalazioneAccountChiusuraForm { 
    version: number;
    esito: SegnalazioneAccountChiusuraFormEsitoEnum;
    nota?: string;
}
export enum SegnalazioneAccountChiusuraFormEsitoEnum {
    ACCOUNT_ABUSIVO_ANONIMIZZATO = 'ACCOUNT_ABUSIVO_ANONIMIZZATO',
    NESSUN_ABUSO = 'NESSUN_ABUSO',
    RITIRATA_DAL_SEGNALANTE = 'RITIRATA_DAL_SEGNALANTE',
    ALTRO = 'ALTRO'
};



